import { useGate, useUnit } from 'effector-react';
import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
} from '@mui/material';
import { Listbox } from '../../components/listbox';
import { withControl } from '../../hoc/withControl';
import { EnterpriseConfirmationModeGate, enterpriseConfirmationModeQuery } from './model';
import { EnterpriseConfirmationMode } from './types';

type Props = {
  disableClearable?: boolean;
};

export const EnterpriseConfirmationModeControl = withControl<Props>(
  ({
    label,
    value,
    setValue,
    error,
    required,
    readOnly,
    disabled,
    isError,
    disableClearable,
  }) => {
    useGate(EnterpriseConfirmationModeGate);
    const { data, pending } = useUnit(enterpriseConfirmationModeQuery);

    const findedValue =
      value !== ''
        ? data?.find(
            (item: EnterpriseConfirmationMode) =>
              item.id === (typeof value === 'object' ? value?.id : value)
          )
        : null;

    const handleChange = (_: unknown, newValue: any) => setValue(newValue || null);

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <Autocomplete
          disableClearable={disableClearable}
          loading={pending}
          value={!data ? null : findedValue || null}
          options={!data ? [] : data}
          onChange={handleChange}
          ListboxComponent={Listbox}
          renderInput={(params): JSX.Element => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                error: isError,
                readOnly,
                endAdornment: readOnly ? null : (
                  <>
                    {pending && <CircularProgress size={20} color="inherit" />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          readOnly={readOnly}
          disabled={disabled}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
